import type en from "../en/auth";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  metaLogin: "تسجيل الدخول",
  metaRegister: "إنشاء حسابك",
  metaForgot: "إعادة تعيين كلمة المرور",
  metaReset: "اختيار كلمة مرور جديدة",
  metaVerify: "تأكيد بريدك الإلكتروني",
  loginTitle: "مرحبًا بعودتك",
  loginSubtitle: "سجّل الدخول لإدارة متاجرك.",
  passwordChanged: "تم تغيير كلمة المرور. سجّل الدخول باستخدام كلمة المرور الجديدة.",
  newToStorelancer: "جديد على Storelancer؟",
  createAnAccount: "أنشئ حسابًا",
  registerTitle: "إنشاء حسابك",
  registerSubtitle: "ابدأ بخطة Starter المجانية. لا حاجة إلى بطاقة دفع.",
  haveAccount: "لديك حساب بالفعل؟",
  signIn: "تسجيل الدخول",
  signingIn: "جارٍ تسجيل الدخول…",
  forgotTitle: "إعادة تعيين كلمة المرور",
  forgotSubtitle: "أدخل البريد الإلكتروني لحسابك وسنرسل إليك رابطًا لإعادة التعيين.",
  backToSignIn: "العودة إلى تسجيل الدخول",
  resetTitle: "اختيار كلمة مرور جديدة",
  resetLinkIncomplete: "رابط إعادة التعيين هذا غير مكتمل.",
  requestNewOne: "اطلب رابطًا جديدًا",
  verifyTitle: "تأكيد البريد الإلكتروني",
  verifyLinkIncomplete: "رابط التأكيد هذا غير مكتمل.",
  verifyRequestNew: "يمكنك طلب رابط جديد من إعدادات حسابك.",
  verifySuccess: "تم تأكيد عنوان بريدك الإلكتروني.",
  goToDashboard: "الانتقال إلى لوحة التحكم",
  fieldEmail: "البريد الإلكتروني",
  fieldPassword: "كلمة المرور",
  fieldName: "اسمك",
  fieldNewPassword: "كلمة المرور الجديدة",
  fieldConfirmPassword: "تأكيد كلمة المرور",
  forgotLink: "نسيت كلمة المرور؟",
  passwordHint: "10 أحرف على الأقل، تتضمن حرفًا ورقمًا.",
  termsAgree: "أوافق على {terms} و{privacy}",
  termsLink: "شروط الخدمة",
  privacyLink: "سياسة الخصوصية",
  createAccount: "إنشاء الحساب",
  creatingAccount: "جارٍ إنشاء الحساب…",
  sendResetLink: "إرسال رابط إعادة التعيين",
  sending: "جارٍ الإرسال…",
  setNewPassword: "تعيين كلمة المرور الجديدة",
  acceptTerms: "يُرجى قبول شروط الخدمة.",
  required: "مطلوب",
  resetSent: "إذا كان هناك حساب مرتبط بهذا البريد الإلكتروني، فقد أرسلنا إليه رابطًا لإعادة التعيين. تنتهي صلاحية الرابط خلال ساعة واحدة.",
  passwordsDontMatch: "كلمتا المرور غير متطابقتين.",
};

export default ar;
